import React, { useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import { ReactComponent as AI } from '../../assets/landing-page/about-us/ai.svg';
import { ReactComponent as Bullseye } from '../../assets/landing-page/about-us/bullseye.svg';
import { ReactComponent as Energy } from '../../assets/landing-page/about-us/energy.svg';
import { ReactComponent as WalkspanLogo } from '../../assets/walkspan-logo.svg';

import { FaEnvelope, FaLinkedin } from 'react-icons/fa';

import { teamData, advisorsData } from '../../constants';
import Bernardita from '../../assets/landing-page/team/bernardita_2.png';
import Stefanie from '../../assets/landing-page/team/Stefanie_E.jpg';
import Deepti from '../../assets/landing-page/team/Deepti M.png';
import Banner from '../../assets/landing-page/about-banner.jpg';

const About2 = () => {
  const { state } = useContext(StoreContext);
  const { isMobile } = state;
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 4,
    swipeToSlide: false,
    arrows: true,
  };

  const aboutData = [
    {
      icon: AI,
      description: 'We are a data and technology company dedicated to accelerating public realm transformation through AI- driven metrics.'
    },
    {
      icon: Energy,
      description: 'Walkspan is a sustainable company with a unique value system and mission to shape the public realm of tomorrow. We are passionate about celebrating neighborhood character and quality.'
    },
    {
      icon: Bullseye,
      description: 'We are impact entrepreneurs, an interdisciplinary team in the technology, location intelligence, data, and environmental fields.'
    },
  ]

  return (
    <div className='About'>
      <section className='who-we-are py-20'>
        {/* <LazyImage src={BG1} placeholder={BG1PH} alt='' /> */}
        <div className="px-4 mt-0 md:mt-20 text-black text-6xl">
          About <span className='text-[#f1592a]'>Walkspan</span>
        </div>
        <div className="bg-white min-h-[calc(70svh-132px)] py-12 px-8 bg-abstract">
          <div className='text-[20px] text-center text-black leading-[1.58] mx-auto px-0 md:px-12 mb-12 max-w-[1150px]'>
            Founded in 2019, Walkspan is revolutionizing real estate by emphasizing the importance of place and 
            walkable urban living. Created by a team of experts in location intelligence, real estate, 
            sustainability, and urban planning with over 30 years of combined experience on award-winning 
            projects, Walkspan stands as the only neighborhood search platform of its kind.
          </div>
          <img src={Banner} alt="about-us-banner" className='hidden md:inline mb-12 max-w-[1050px] mx-auto' />
          <div className="max-w-screen-xl mx-auto text-lg grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
            {aboutData.map((item, index) => (
                <div className="about-data bg-[#3a3e49] text-white py-10 px-6 shadow-md flex flex-col gap-2">
                    {item.icon && <item.icon className='w-12 h-12 mb-4 mx-auto' />}
                    <div className='text-center'>
                        {item.description}
                    </div>
                </div>
            ))}
            {/* <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                Walkspan is a sustainable company with a unique value system and 
                mission to shape the public realm of tomorrow. We are passionate about 
                celebrating <b>neighborhood character and quality</b>.
              </div>
            </div>
            <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                We are a data and  <b>technology company</b> dedicated to accelerating 
                public realm transformation through <b>AI-driven metrics</b>.
              </div>
            </div>
            <div className="bg-[#1c293a] text-white p-6 shadow-md flex">
              <div className='text-center'>
                We are impact entrepreneurs, an interdisciplinary team in the technology, 
                <b> location intelligence</b>, data, and environmental fields.
              </div>
            </div> */}
          </div>
        </div>
        {/* <section className='what-we-do max-w-screen-lg'>
          <h1 className='landing-title'>What We Do</h1>
          <p>
            Walkspan reveals neighborhood character and quality through its
            neighborhood intelligence platform. A platform that seamlessly
            integrates with real estate search engines to help buyers and
            renters find homes in walkable neighborhoods. Buying homes where
            lifestyle essentials are within walking distance improves quality of
            life and brings sustainable impacts.
          </p>
        </section> */}
      </section>
      <div className="founders-section bg-white pb-12">
        <div className="years text-white text-center bg-[#1c293a] mx-auto p-14 md:p-20 h-[600px] flex items-center">
          <div className='text-4xl md:text-6xl max-w-screen-lg leading-snug'>
            We have <span className='text-[#f1592a]'>35 years</span> of combined experience in data management, location intelligence, urban studies, and operations.
          </div>
        </div>
        <div className="team-section">
          <div className="absolute flex items-center justify-start inset-0 pointer-events-none select-none">
            <WalkspanLogo
              aria-hidden
              className="w-[70%] h-[90%] opacity-30"
            />
          </div>
          <div className="absolute inset-0 bg-white/50 w-full"></div>
          <div className='relative max-w-screen-xl mx-auto pt-12 px-8 pb-16 z-10'>
            <div className='relative flex flex-col gap-6 items-center z-10'>
              <div className='text-4xl md:text-6xl'>
                Meet the <span className='text-[#f1592a]'>Team</span>
              </div>
              <div className='text-lg max-w-[800px]'>
                Walkspan is fortunate to be fully supported by an amazing team of software
                developers, data scientists, location and urban planning experts in the US and abroad.
              </div>
            </div>
            <div className='relative flex flex-col gap-16 mt-16 z-10'>
              <div className='flex flex-col-reverse lg:flex-row gap-6 items-center justify-center flex-wrap'>
                <div className='flex flex-col gap-4'>
                  <div className="flex flex-col text-center md:text-left">
                    <div className="text-2xl md:text-4xl font-medium">Bernardita Calinao, PhD</div>
                    <p className="text-xl md:text-3xl mt-2">Founder and CEO</p>
                  </div>
                  <div className="text-xl leading-7 text-center md:text-left w-full md:max-w-[700px]">
                    <p>
                      Bernardita is a Human Ecologist and Environmental
                      Planner passionate about walkability, livability, and
                      sustainability. She has led 35+ environmental studies for
                      multimillion-dollar projects worldwide, working with
                      governments, private sectors, and indigenous
                      communities. Her award-winning projects used GIS to map
                      impacts and create solutions.
                    </p>
                    <p className="mt-6">
                      Six years ago, she founded Walkspan, drawing from her
                      extensive work in urban and transportation planning.
                      Today, she leads efforts to advance walkability using the
                      world's largest repository of walking-environment data.
                      Bernardita holds a PhD and Master's in Environmental
                      Science from SUNY-ESF, Syracuse.
                    </p>
                    <div className='flex gap-2 items-center justify-center md:justify-start advisor-links mt-6'>
                      <a
                        href="https://www.linkedin.com/in/bernarditacaliano"
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <FaLinkedin color='#f1592a' size={32} />
                      </a>
                      <a href="mailto:bernardita@example.com">
                        <FaEnvelope color='#f1592a' size={32} />
                      </a>
                    </div>
                  </div>
                </div>
                <img
                  src={Bernardita} 
                  alt="Bernardita Calinao, PhD"
                  className="w-48 h-48 md:w-64 md:h-64 rounded-full object-cover"
                />
              </div>
              <div className='flex flex-row gap-6 items-center justify-center flex-wrap'>
                <img
                  src={Stefanie} 
                  alt="Stefanie Eimesser"
                  className="w-48 h-48 md:w-64 md:h-64 rounded-full object-cover"
                />
                <div className='flex flex-col gap-4'>
                  <div className="flex flex-col text-center md:text-right">
                    <div className="text-2xl md:text-4xl font-medium">Stefanie Eimesser</div>
                    <p className="text-xl md:text-3xl mt-2">Chief Marketing Officer and</p>
                    <p className="text-xl md:text-3xl mt-2">Business Development Manager</p>
                  </div>
                  <div className="text-lg leading-7 text-center md:text-right w-full md:max-w-[700px]">
                    <p>
                      Stefanie is passionate about connecting people, places, and
                      opportunities through innovative marketing and strategic
                      partnerships. With over a decade of global experience in brand
                      management, marketing, and key accounts across FMCG, lifestyle,
                      and travel industries, she has led growth-driven strategies for
                      major international brands.
                    </p>
                    <p className="mt-6">
                      At Walkspan, she drives brand strategy, market expansion, and
                      client engagement—showcasing the power of walkability and
                      livability data for real estate, urban development, and the travel
                      sector. Originally from Bavaria, Germany, Stefanie moved to New
                      York City in 2023 after winning the U.S. Green Card Lottery. She
                      holds a Master’s in Marketing Management and is known for
                      turning complex challenges into creative, actionable solutions.
                    </p>
                    <div className='flex gap-2 items-center justify-center md:justify-end advisor-links mt-6'>
                      <a
                        href="https://www.linkedin.com/in/bernarditacaliano"
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <FaLinkedin color='#f1592a' size={32} />
                      </a>
                      <a href="mailto:bernardita@example.com">
                        <FaEnvelope color='#f1592a' size={32} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="relative advisor-section text-black py-24 px-8 overflow-hidden">
        <div className="absolute flex items-center justify-start inset-0 pointer-events-none select-none">
          <WalkspanLogo
            aria-hidden
            className="w-[70%] h-[90%] opacity-30"
          />
        </div>

        <div className="relative z-10">
          <h2 className="text-4xl md:text-6xl">
            Meet Our <span className="text-[#f1592a]">Advisors</span>
          </h2>

          <p className="mx-auto text-2xl mt-8 max-w-screen-lg">
            We have a <span className="text-[#f1592a]">network of professionals</span> in real estate technology
            and marketing to create synergies and share ideas on walkability.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mt-8 mx-auto max-w-screen-xl">
            {advisorsData.map((advisor, index) => (
              <div key={index} className="flex flex-col items-center justify-center text-center p-5 gap-2">
                <img
                  src={advisor.img}
                  alt={advisor.name}
                  className="w-40 h-40 sm:w-[250px] sm:h-[250px] object-cover mb-4"
                />
                <h3 className="font-semibold text-xl uppercase">{advisor.name}</h3>
                <p className='text-lg'>{advisor.title}</p>
                <div className="flex gap-3 advisor-links mt-3">
                  <a
                    href={advisor.linkedIn}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${advisor.name} on LinkedIn`}
                  >
                    <FaLinkedin className="w-7 h-7" color="#f1592a" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About2;
